import * as _ from 'lodash'
import React, { useEffect, useMemo, useState } from 'react';
import * as actions from '../actions';
import * as jobActions from '../jobActions';import * as contractorActions from '../contractorActions';
import * as employeeActions from '../employeeActions';
import enums from '../enum';
import componentServices from '../componentServices';
import { useSaveRoot } from '../saveRoot';
import jobFactory, { IJob } from '../models/jobModel';
import contactModel from '../models/contactModel';

import JobEditOverview from './jobEditOverview';
import { Alert, ColumnSelector, SearchForm, sortableComponent, Spinner, ViewPager } from './sharedComponents';
import { IPatchOperation } from '../modelFactory';
import { getCollection, getModel, ModelCollection } from '../store';

const ClientTable = sortableComponent(class ClientTableInner extends React.Component<any,any> {
	handleClick (k, e) {
		e.preventDefault();
		this.props.updateSort(k);
	}

	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}

	render () {
		const { list, ...childProps } = this.props;
		const rows = list.map((item) => {
			const key = 'clientContact-' + item.contact.key;

			return (<ClientTableRow contact={ item.contact } jobs={ item.jobs } mostRecentAddress={ item.mostRecentAddress } mostRecentDesigner={ item.mostRecentDesigner } key={ key } {...childProps} />);
		});

		return (
			<table className="sortable interactive" cellPadding="0" cellSpacing="0">
				<thead>
					<tr>
						<td />
						<td className={this.getClassName('contact.lastName')} onClick={this.handleClick.bind(this, 'contact.lastName')}>Last</td>
						<td className={this.getClassName('contact.firstName')} onClick={this.handleClick.bind(this, 'contact.firstName')}>First</td>
						<td className={this.getClassName('jobSort')} onClick={this.handleClick.bind(this, 'jobSort')}>Previous Jobs</td>
						<td className={this.getClassName('mostRecentDesigner')} onClick={this.handleClick.bind(this, 'mostRecentDesigner')}>Designer</td>
						<td className={this.getClassName('mostRecentAddress')} onClick={this.handleClick.bind(this, 'mostRecentAddress')}>Last Address</td>
						<td />
					</tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
			</table>
		);
	}
});

class ClientTableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick (e) {
		e.preventDefault();
		this.props.next({ contact: this.props.contact });
	}

	render () {
		const { contact, jobs, mostRecentAddress, mostRecentDesigner } = this.props;
		const jobIds = _.map(jobs, j => j.relayNumber).join(', '); // this allows the potential to make the jobs interactive in the future

		return (
			// Don't forget to add back the handleClick handler once I get that worked out
			<tr onClick={this.handleClick}>
				<td />
				<td>{ contact.lastName }</td>
				<td>{ contact.firstName }</td>
				<td>{ jobIds }</td>
				<td className="nowrap">{ mostRecentDesigner }</td>
				<td className="nowrap">{ mostRecentAddress }</td>
				<td />
			</tr>
		);
	}
}

const ContractorTable = sortableComponent(class ContractorTableInner extends React.Component<any,any> {
	handleClick (k, e) {
		e.preventDefault();
		this.props.updateSort(k);
	}

	getClassName (key) {
		return (key === this.props.sortKey) ? 'sorted' : '';
	}

	render () {
		const { list, ...childProps } = this.props;
		const rows = list.map((item) => {
			const key = 'contractor-' + item.key;

			return (<ContractorTableRow contractor={ item } key={ key } {...childProps} />);
		});

		return (
			<table className="sortable interactive" cellPadding="0" cellSpacing="0">
				<thead>
					<tr>
						<td />
						<td className={this.getClassName('name')} onClick={this.handleClick.bind(this, 'name')}>Name</td>
						<td className={this.getClassName('primaryContactName')} onClick={this.handleClick.bind(this, 'primaryContactName')}>Primary Contact</td>
						<td className={this.getClassName('workPhoneNumber')} onClick={this.handleClick.bind(this, 'workPhoneNumber')}>Office Phone</td>
						<td />
					</tr>
				</thead>
				<tbody>
					{rows}
				</tbody>
			</table>
		);
	}
});

class ContractorTableRow extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleClick = this.handleClick.bind(this);
	}

	handleClick (e) {
		e.preventDefault();
		this.props.next({ contractor: this.props.contractor });
	}

	render () {
		const { contractor } = this.props;

		return (
			// Don't forget to add back the handleClick handler once I get that worked out
			<tr onClick={this.handleClick}>
				<td />
				<td>{ contractor.name }</td>
				<td>{ contractor.primaryContactName }</td>
				<td className="nowrap">{ contractor.workPhoneNumber }</td>
				<td />
			</tr>
		);
	}
}

const ClientSearchResults = ({ list, next, ...rest }) => {
	return (
		<section>
			<ClientTable list={ list } initialSortKey="contact.lastName" next={ next } {...rest} />
		</section>
	);
};

const ContractorSearchResults = ({ list, next, ...rest }) => {
	return (
		<section>
			<ContractorTable list={ list } initialSortKey="name" next={ next } {...rest} />
		</section>
	);
};

class ExistingClientSearch extends React.PureComponent<any, any> {
	render () {
		const classes = ['content', 'scrollable'].concat(this.props.classes);
		let resultsSection;

		if (this.props.list && this.props.list.length) {
			resultsSection = (<ClientSearchResults list={ this.props.list } next={ this.props.next } />);
		}

		return (
			<div className={classes.join(' ')}>
				<section>
					<header>
						<span className="centered">Find Existing Client</span>
						<button className="icon iconOnly previous" onClick={ this.props.previousHandler }><span /></button>
					</header>
					<section className="inner">
						<SearchForm onSearch={ this.props.onSearch } initialSearchText={ this.props.searchText } />
					</section>
					{ resultsSection }
				</section>
			</div>
		);
	}
}

class ContractorSearch extends React.PureComponent<any, any> {
	render () {
		let resultsSection;

		if (this.props.list && this.props.list.length) {
			resultsSection = (<ContractorSearchResults list={ this.props.list } next={ this.props.next } />);
		}

		return (
			<section>
				<header>
					<span className="centered">{ this.props.title }</span>
					<button className="icon iconOnly previous" onClick={ this.props.previousHandler }><span /></button>
				</header>
				<section className="inner">
					<SearchForm onSearch={ this.props.onSearch } initialSearchText={ this.props.searchText } />
				</section>
				{ resultsSection }
			</section>
		);
	}
}

const NewClientSearchResults = ({ list, previousHandler, nextExisting, nextNew }) => {
	return (<section>
		<header>
			<span className="centered">Existing Clients Found</span>
			<button className="icon iconOnly previous" onClick={ previousHandler }><span /></button>
		</header>
		<section className="inner centered">
					There are some client names similar to the one you entered - you can select an existing client below or <a className="cta" onClick={ nextNew }>continue adding as a new client</a>.
		</section>
		<ClientSearchResults list={ list } next={ nextExisting } />
	</section>);
};

class NewClientSearchForm extends React.PureComponent<any, any> {
	private _firstNameRef;
	private _lastNameRef;

	constructor (props) {
		super(props);

		this.onChange = this.onChange.bind(this);
		this._firstNameRef = React.createRef();
		this._lastNameRef = React.createRef();
	}

	onChange (e) {
		e.preventDefault();

		this.props.onClientSpecUpdated(this._firstNameRef.current.value, this._lastNameRef.current.value);
	}

	render () {
		const firstName = (this.props.clientSpec) ? this.props.clientSpec.firstName : '';
		const lastName = (this.props.clientSpec) ? this.props.clientSpec.lastName : '';

		return (
			<section>
				<header>
					<span className="centered">Enter Primary Client Name</span>
					<button className="icon iconOnly previous" onClick={ this.props.previousHandler }><span /></button>
					<button className={ 'icon iconOnly next' + (!firstName || !lastName ? ' disabled' : '') } onClick={ this.props.next }><span /></button>
				</header>
				<section>
					<table className="half centered" cellPadding="0" cellSpacing="0">
						<tbody>
							<tr className={!firstName ? 'required' : ''}>
								<td />
								<td><strong>First Name</strong></td>
								<td><input type="text" placeholder="First Name" autoCapitalize="" autoCorrect="off" value={ firstName } onChange={ this.onChange } ref={ this._firstNameRef } /></td>
								<td />
							</tr>
							<tr className={!lastName ? 'required' : ''}>
								<td />
								<td><strong >Last Name</strong></td>
								<td><input type="text" placeholder="Last Name" autoCapitalize="" autoCorrect="off" value={ lastName } onChange={ this.onChange } ref={ this._lastNameRef } /></td>
								<td />
							</tr>
						</tbody>
					</table>
				</section>
			</section>
		);
	}
}

const jobsToSearchResults = jobs => {
	const results = {};
	const contacts = {};
	const { store } = componentServices;
	const employeeCursor = getCollection({ store, collection: ModelCollection.employees });

	// get a dictionary of all contacts
	_.forEach(jobs, job => {
		_.forEach(job.clientContacts, clientContact => {
			contacts[clientContact.key] = clientContact;
		});
	});

	const getRootContact = contact => {
		let result = contact;

		while (result.parentContactKey) {
			const parent = contacts[result.parentContactKey];
			if (parent) {
				result = parent;
			}
			else {
				break;
			}
		}

		return result;
	};

	// sort the jobs by most recent first to be sure that we capture the most recent designer and address
	_.forEach(_.orderBy(jobs, ['dateCreated'], ['desc']), job => {
		_.forEach(job.clientContacts, clientContact => {
			const rootContact = getRootContact(clientContact);
			const resultItem = results[rootContact.key];

			if (!resultItem) {
				const employee = job.accountManagerKey && employeeCursor.get(job.accountManagerKey);
				results[rootContact.key] = {
					jobs: [job],
					mostRecentDesigner: employee ? employee.fullName : 'Unknown',
					mostRecentAddress: job.workSiteAddress ? `${job.workSiteAddress.street}, ${job.workSiteAddress.city}, ${job.workSiteAddress.region} ${job.workSiteAddress.postalCode}` : '',
					contact: clientContact
				};
			}
			else if (!_.some(resultItem.jobs, { key: job.key })) {
				resultItem.jobs.push(job);
			}
		});
	});

	_.forEach(results, result => {
		result.jobSort = _.map(result.jobs, j => j.relayNumber).join(', ');
	});

	return _.values(results);
};

// full definition of nodes for the column selector
// if a business segment is supplied, this will be trimmed as appropriate
const _selectorNodes = [{
	key: 'builder',
	title: 'Builder',
	businessSegment: enums.businessSegments.Builder,
	classes: ['icon', 'iconLabel', 'builder'],
	children: [] // will be populated dynamically
}, {
	key: 'multi-family',
	title: 'Multi Family',
	businessSegment: enums.businessSegments.Multifamily,
	classes: ['icon', 'iconLabel', 'multiFamily'],
	children: []
}, {
	key: 'retail',
	title: 'Retail',
	businessSegment: enums.businessSegments.Retail,
	classes: ['icon', 'iconLabel', 'retail'],
	children: [{
		key: 'new-home',
		title: 'New Home',
		isRenovation: false,
		children: [{
			key: 'existing-client',
			title: 'Existing Client'
		}, {
			key: 'new-client',
			title: 'New Client'
		}, {
			key: 'retail-builder',
			title: 'Retail Builder'
		}]
	}, {
		key: 'renovation',
		title: 'Renovation',
		isRenovation: true,
		children: [{
			key: 'existing-client',
			title: 'Existing Client'
		}, {
			key: 'new-client',
			title: 'New Client'
		}, {
			key: 'renovation-contractor',
			title: 'Renovation Contractor'
		}]
	}]
}];

let _employeeFetch;
export default function NewJobWorkflow(props) {
	const { businessSegment } = props;

	const rootSelectorNode = useMemo(() => {
		if (businessSegment) {
			const rootNode = _.find(_selectorNodes, { businessSegment });

			if (businessSegment === enums.businessSegments.Builder) {
				const developerType = enums.contractorTypes.Developer;
				const buildChildNodes = () => {
					const { store } = componentServices;
					const childNodes = [];

					getCollection({ store, collection: ModelCollection.contractors} ).filter(c => (c.type & developerType) === developerType && c.currentStatus !== 'locked').sortBy(c => c.name).forEach(function (c) {
						childNodes.push({ key: c.key, title: c.name });
					});

					return childNodes;
				};

				rootNode.children = buildChildNodes();

				contractorActions.fetchContractors({ filters: { type: developerType } })
					.then(() => {
						updateState(nextState => {
							nextState.nodes = buildChildNodes();
						});
					});
			}

			return rootNode;
		}
		else {
			return { children: _selectorNodes };
		}
	}, [businessSegment]);
	const [state, setState] = useState({
		title: props.initialTitle,
		viewIndex: 0,
		searchText: undefined,
		searchResults: [],
		clientSpecValid: false,
		clientSpec: undefined,
		builder: undefined,
		jobInfo: undefined,
		builderTitle: undefined,
		isRenovation: false,
		searchingForClient: false,
		workflowPathPrefix: rootSelectorNode.key,
		workflowPath: rootSelectorNode.key,
		nodes: rootSelectorNode.children,
	});
	const [saveRoot] = useSaveRoot<IJob>({
		autoSave:  false,
		globalSave: false,
		warnOnLeave: false,
		stateId: 'NewJobWorkflow',
		modelFactory: jobFactory,
		resolveMutableModel (current) {
			let job = current;

			if (!current && state.jobInfo) {
				job = jobFactory(state.jobInfo);
			}
			else if (!state.jobInfo) {
				job = undefined;
			}

			return [job];
		},
		save: (doc, patch: IPatchOperation[]) => jobActions.saveJob({ job: doc, patch }),
		savedCallback: (status) => {
			if (!status.error) {
				props.close();
			}
		},
		processAlert: alert => {
			alert.message = alert.message.replace('Client Contacts 1', 'Primary Client Contact');
			return alert;
		},
		validate(model) {
			return model.test() || [];
		}
	});


	useEffect(() => {
		_employeeFetch = employeeActions.fetchEmployees();
	}, []);

	function updateState (updater) {
		const nextState = {...state};
		const oldViewIndex = nextState.viewIndex;

		updater(nextState);

		const direction = nextState.viewIndex - oldViewIndex;

		if (direction !== 0) {
			if (nextState.viewIndex === 0) {
				nextState.title = props.initialTitle;
				nextState.searchText = undefined;
				nextState.clientSpec = undefined;
				nextState.searchResults = [];
				nextState.builder = undefined;
				nextState.jobInfo = undefined;
				nextState.clientSpecValid = false;
			}

			if (direction < 0) {
				nextState.builder = undefined;
				nextState.jobInfo = undefined;
			}
		}

		setState(nextState);
	}

	function cancel (e) {
		e.preventDefault();
		props.close();
	}

	function getViewFactories () {
		const factories = [];

		// always include the column selector
		factories.push(addColumnSelector);

		// builder search view
		const matches = /retail\.[\w-]*\.(retail-builder|renovation-contractor)/i.exec(state.workflowPath);

		if (matches && matches.length > 0) {
			state.builderTitle = (matches[1] === 'retail-builder') ? 'Retail Builder' : 'Renovation Contractor';
			factories.push(addBuilderSearch);
		}

		// new client search
		if (/retail\.[\w-]*\.new-client/i.test(state.workflowPath)) {
			factories.push(addNewClientSearch);
		}

		// existing client search
		if (/retail\.[\w-]*\.existing-client/i.test(state.workflowPath)) {
			factories.push(addExistingClientSearch);
		}

		// new client search results
		if (/retail\.[\w-]*\.new-client/i.test(state.workflowPath) && state.searchResults && state.searchResults.length) {
			factories.push(addNewClientSearchResults);
		}

		// Add the editor
		if (saveRoot.model) {
			factories.push(addJobClientEdit);
		}

		return factories;
	}

	function onJobSearch (searchState) {
		const modalKey = 'new-job-workflow-job-search';

		updateState(nextState => { nextState.searchText = searchState.searchText; });
		actions.pushModal({ key: modalKey, component: (<Spinner />) });
		_employeeFetch
			.then(() => {
				return jobActions.searchJobs({
					client: {
						firstName: searchState.searchText,
						lastName: searchState.searchText,
						emailAddress: searchState.searchText
					}
				});
			}).then(jobs => {
				updateState(nextState => { nextState.searchResults = jobsToSearchResults(jobs); });
			}).finally(() => {
				actions.deleteModal({ key: modalKey });
			});
	}

	function onContractorSearch (searchState) {
		const matches = /\.(retail-builder|renovation-contractor)/i.exec(state.workflowPath);
		const modalKey = 'new-job-workflow-contractor-search';

		updateState(nextState => { nextState.searchText = searchState.searchText; });
		actions.pushModal({ key: modalKey, component: (<Spinner />) });
		contractorActions.searchContractors({
			filters: {
				type: matches[1] === 'retail-builder' ? 1 : 2,
				name: searchState.searchText
			}
		}).then(contractors => {
			updateState(nextState => {
				nextState.searchResults = _.filter(contractors, c => c.currentStatus !== 'locked');
			});
		}).finally(() => {
			actions.deleteModal({ key: modalKey });
		});
	}

	function handleColumnSelectorState (selectorState) {
		const { store } = componentServices;

		if (selectorState.type === 'selected') {
			updateState(nextState => {
				nextState.workflowPath = nextState.workflowPathPrefix ? [nextState.workflowPathPrefix, selectorState.selectedPath].join(selectorState.pathSeparator) : selectorState.selectedPath;
				nextState.pathSeparator = selectorState.pathSeparator;
			});
		}
		else if (selectorState.type === 'completed') {
			const { businessSegment } = props;

			if (businessSegment === enums.businessSegments.Retail) {
				const pathParts = state.workflowPath.split('.');
				if (pathParts.length < 2) {
					return;
				}

				// let businessSegment;
				let isRenovation;
				const title = _.map(state.nodes, function (node) {
					// get isRenovation as side-effect of title iteration
					if (node.isRenovation && pathParts.indexOf(node.key)!=-1) {
						isRenovation = node.isRenovation;
					}

					return node.title;
				}).join(' / ');

				updateState(nextState => {
					nextState.viewIndex = 1;
					nextState.workflowPath = nextState.workflowPathPrefix ? [nextState.workflowPathPrefix, selectorState.selectedPath].join(selectorState.pathSeparator) : selectorState.selectedPath;
					nextState.pathSeparator = selectorState.pathSeparator;
					nextState.title = title;
					nextState.isRenovation = !!isRenovation;
				});
			}
			else if (businessSegment === enums.businessSegments.Builder) {
				const contractorKey = selectorState.selectedPath;
				const contractor = getModel({ store, collection: ModelCollection.contractors, key: contractorKey });

				if (contractor) {
					contractorActions.fetchContractor({ key: contractor.key });
					setJobInfo(undefined, contractor);
				}
			}
		}
	}

	function handleSelectClientState (state) {
		setClient(state.contact);
	}

	function handleSelectContractorState (state) {
		setJobInfo(undefined, state.contractor);
	}

	function handleContinueWithNewClientClick (e) {
		e.preventDefault();
		setNewClient(state.clientSpec);
	}

	function handlePreviousClick (e) {
		e.preventDefault();
		const newIndex = Math.max(0, state.viewIndex - 1);

		updateState(nextState => {
			nextState.viewIndex = newIndex;
		});
	}

	function handleNewClientNextClick (e) {
		e.preventDefault();

		const modalKey = 'new-job-workflow-new-client-search';

		if (!state.searchingForClient && state.clientSpecValid) {
			updateState(nextState => { nextState.searchingForClient = true; });
			actions.pushModal({ key: modalKey, component: (<Spinner />) });

			_employeeFetch
				.then(() => {
					return jobActions.searchJobs({
						client: state.clientSpec
					});
				}).then(jobs => {
					if (jobs && jobs.length) {
						updateState(nextState => {
							nextState.searchResults = jobsToSearchResults(jobs);
							nextState.searchingForClient = false;
							nextState.viewIndex = 2;
						});
					}
					else {
						updateState(nextState => {
							nextState.searchResults = jobsToSearchResults(jobs);
							nextState.searchingForClient = false;
						});
						setNewClient(state.clientSpec);
					}
				})
				.catch(err => {
					updateState(nextState => { nextState.searchingForClient = false; });
				})
				.finally(() => {
					actions.deleteModal({ key: modalKey });
				});
		}
	}

	function setNewClient (clientSpec) {
		setJobInfo(contactModel(_.assign({}, clientSpec, { priority: 0 })));
	}

	function setClient (contact) {
		setJobInfo(contact.createChild({ prority: 0 }));
	}

	function setJobInfo (contact, builder?) {
		const { businessSegment } = props;
		const jobInfo = { businessSegment, isRenovation: state.isRenovation, notes: [], clientContacts: [], builderKey: ''};
		const viewIndex = state.viewIndex + 1;

		if (contact) { jobInfo.clientContacts = [contact]; }
		if (builder) { jobInfo.builderKey = builder.key; }

		updateState((newState) => {
			newState.viewIndex = viewIndex;
			newState.jobInfo = jobInfo;
		});
	}

	function handleClientSpecUpdate (firstName, lastName) {
		const clientSpec = {
			firstName: firstName,
			lastName: lastName
		};

		updateState(nextState => {
			nextState.clientSpec = clientSpec;
			nextState.clientSpecValid = !!clientSpec.firstName && !!clientSpec.lastName;
		});
	}

	function addColumnSelector (childViews, viewClasses) {
		const { businessSegment } = props;
		const key = 'childView_' + childViews.length;
		const pathSeparator = '.';
		const selectedPathParts = state.workflowPath ? state.workflowPath.split(pathSeparator) : [];
		if (state.workflowPathPrefix) {
			selectedPathParts.splice(0, 1);
		}
		const selectedPath = selectedPathParts.join(pathSeparator);

		childViews.push(
			<ColumnSelector
				key={key}
				stateChanged={handleColumnSelectorState}
				nodes={ state.nodes }
				selectedPath={ selectedPath }
				pathSeparator={pathSeparator}
				nextDisabled={ (businessSegment === enums.businessSegments.Builder) ? (selectedPathParts === 0) : (selectedPathParts.length < 2) } />
		);

		viewClasses.push('');
	}

	function addExistingClientSearch (childViews, viewClasses) {
		const key = 'childView_' + childViews.length;

		childViews.push(
			<ExistingClientSearch
				key={key}
				searchText={ state.searchText }
				list={ state.searchResults }
				onSearch={ onJobSearch }
				previousHandler={ handlePreviousClick }
				next= { handleSelectClientState } />
		);

		viewClasses.push('');
	}

	function addNewClientSearch (childViews, viewClasses) {
		const key = 'childView_' + childViews.length;

		childViews.push(
			<NewClientSearchForm
				key={key}
				previousHandler={ handlePreviousClick }
				next= { handleNewClientNextClick }
				onClientSpecUpdated= { handleClientSpecUpdate }
				clientSpec= { state.clientSpec } />
		);

		viewClasses.push('');
	}

	function addNewClientSearchResults (childViews, viewClasses) {
		const key = 'childView_' + childViews.length;

		childViews.push(
			<NewClientSearchResults
				key={key}
				list={ state.searchResults }
				previousHandler={ handlePreviousClick }
				nextExisting= { handleSelectClientState }
				nextNew= { handleContinueWithNewClientClick } />
		);

		viewClasses.push('');
	}

	function addBuilderSearch (childViews, viewClasses) {
		const key = 'childView_' + childViews.length;

		childViews.push(
			<ContractorSearch
				key={key}
				title={ state.builderTitle }
				searchText={ state.searchText }
				list={ state.searchResults }
				onSearch={ onContractorSearch }
				previousHandler={ handlePreviousClick }
				next= { handleSelectContractorState } />
		);

		viewClasses.push('');
	}

	function addJobClientEdit (childViews, viewClasses) {
		const job = saveRoot.model;
		const key = 'childView_' + childViews.length;

		// set the store as a property to be sure that changes to the store re-render JobEditOverview
		childViews.push(
			<JobEditOverview
				key={ key }
				job={ job }
				store={ props.store }
				previousHandler={ handlePreviousClick }
				updateModel={ updateModel }
				isNewJob={true} />
		);

		viewClasses.push('jobDetail');
	}

	function updateModel (updater, options) {
		saveRoot.update((job) => {
			updater(job);

			if (job.primaryClientContact && job.primaryClientContact.isEmpty()) {
				job.primaryClientContact = undefined;
			}
			if (job.secondaryClientContact && job.secondaryClientContact.isEmpty()) {
				job.secondaryClientContact = undefined;
			}
			if (job.billingAddress && job.billingAddress.isEmpty()) {
				job.billingAddress = undefined;
			}
			if (job.workSiteAddress && job.workSiteAddress.isEmpty()) {
				job.workSiteAddress = undefined;
			}

			if (componentServices.securityContext.currentUserHasFeature('retail-sales', 'manage-leads')) {
				// sets or clears the lead assignment setting based on the value of the accountManagerKey
				job.setSetting(enums.jobSettingGroups.Marketing, 'leadAssigned', job.accountManagerKey || undefined);
			}
		}, options);
	}

	const views = [];
	const viewClasses = [];
	const alerts = [];
	const saveButton = saveRoot.getSaveButton('Save');

	_.forEach(getViewFactories(), f => {
		f(views, viewClasses);
	});

	// TODO: move this to the generic modal component if possible
	componentServices.store.getIn(['viewState', 'alerts']).forEach(function (def) {
		alerts.push(<Alert type={def.type} message={def.message} isCloseable={def.isCloseable} clear={def.clear} key={def.key} />);
	});

	const alertContainer = alerts.length === 0 ? null : (<div className="alerts">{ alerts }</div>);

	return (
		<div className="window">
			<header>
				<button className="cancel" onClick={cancel}><span>Cancel</span></button>
				<span>{ state.title}</span>
				{ saveButton }
			</header>
			{ alertContainer }
			<ViewPager currentIndex={ state.viewIndex } views={views} classes={ viewClasses } />
		</div>
	);
}